import React from 'react'
import Notification from 'src/Components/Notification'
import Routes from 'src/routes'
import BombBomb from './BombBomb'
import DisclaimerModal from './DisclaimerModal'
import ErrorModal from './ErrorModal'

const App = ({ error }) => (
  <>
    <Notification />
    <Routes />
    <BombBomb />
    <DisclaimerModal />
    {error && <ErrorModal />}
  </>
)

export default App
